export default __webpack_public_path__ + "img/accesibilidad-icon.854a729d.png";